export function ensure<T, R extends T>(
  value: T,
  predicate: (value: T) => value is R,
  message: (value: T) => string = () => "Validation failed: Value does not match the predicate."
): asserts value is R {
  if (!predicate(value)) {
    throw new Error(message(value));
  }
}

export type Prettify<T> = {
  [K in keyof T]: T[K];
} & {};
